import { Brick, registerBrick, Transaction, Predicate, Query, WorkflowObjectState } from 'olympe';
import {BCP_WORKFLOW_STATES} from '../../../common/section_bcp/BcpWorkflowAuthorizations';
import BCP from '../../../common/section_bcp/DM_BCP';
import {getCloudObjectWorkflowHistory} from '../../../common/workflows/WorkflowHelpers';
import {getLogger} from '@olympeio/core';

export default class P2P1Migration extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    async update($, inputs, [forwardEvent]) {
        this.logger = getLogger('P2P1Migration');
        // 1. isolate the states that need to be brought back and migrated to
        const bcpWorkflowStateToMigrate = [];
        bcpWorkflowStateToMigrate.push(BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM, BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION);
        // this is the state BCP request will have as current object
        const workflowStateToRevertTo = BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP;

        // 2. Fetch BCP requests with either of the states to migrate
        const statePredicate = Predicate.or(...bcpWorkflowStateToMigrate.map((state) => Predicate.equals(WorkflowObjectState.stateProp, state)));
        const bcpRequests = (await Query.instancesOf(BCP).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(statePredicate).execute()).toArray();

        // 3. Fetch history for each of these bcp requests, delete some workflow object state and set the new current workflow
        const tx = new Transaction();
        for (const bcpRequest of bcpRequests) {

            const bcpRequestHistory = await getCloudObjectWorkflowHistory(bcpRequest);

            // get workflow object with initial workflow we want to revert to:
            const newCurrentWorkflowObject = bcpRequestHistory.find((workflow) => workflow.get(WorkflowObjectState.stateProp) === workflowStateToRevertTo);

            // delete all workflow objects (relations are deleted in cascade) that are other than the first one we migrate to
            const otherWorkflowObjects = bcpRequestHistory.filter((workflow) => workflow.get(WorkflowObjectState.stateProp) !== workflowStateToRevertTo);
            for (const workflowObj of otherWorkflowObjects) {
                this.logger.log(`DELETING STATE + ${workflowObj.get(WorkflowObjectState.stateProp)}`);
                tx.delete(workflowObj);
                // set the notification stage to BP state to allow notifications to be sent for PM/... other steps onwards
                BCP.setNotification_stage(tx, bcpRequest, workflowStateToRevertTo);
            }
            // create relation for new current object:
            tx.createRelation(WorkflowObjectState.currentObjectRel, newCurrentWorkflowObject, bcpRequest);
        }
        // 3. execute the transaction operations to delete all objects and relations, set the new object.
        await tx.execute();

        // Trigger the output Control Flow
        forwardEvent();
    }
}

registerBrick('01944b4ae3415f1613bb', P2P1Migration);
